import { render, staticRenderFns } from "./SubscribeToNewsletter.vue?vue&type=template&id=424be6b4&scoped=true&"
import script from "./SubscribeToNewsletter.vue?vue&type=script&lang=js&"
export * from "./SubscribeToNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424be6b4",
  null
  
)

export default component.exports